import { ContextO } from "../ui";

export function handleKeyOnClick(
  C: ContextO,
  props: { keys: string | string[]; onClick: () => void }
) {
  if (props.keys) {
    C.handlers.keypress = (key) => {
      if (Array.isArray(props.keys)) {
        for (let i = props.keys.length; i >= 0; i--) {
          if (props.keys[i] === key) {
            props.onClick();
            return true;
          }
        }
      } else if (props.keys === key) {
        props.onClick();
        return true;
      }

      return false;
    };
  }
}
